import { action } from 'mobx'
// Request
// Current user
import { CateRequest } from '../requests/CateRequest'

class CateOrganStore {
  @action setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  @action listOrgan = keyword => {
    return new Promise((resolve, reject) => {
      CateRequest.listOrgan({ keyword: keyword?.toLowerCase() })
        .then(response => {
          let list = response?.data?.map(organ => ({
            label: organ.organName,
            value: organ.organId,
          }))
          resolve(list)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default new CateOrganStore()
